import Route from '@ember/routing/route'
import type TeacherToolkitRoute from 'teacher-ui-client/subscription-type/teacher-toolkit/route'

export default class extends Route {
  model() {
    const { selectedCategory } = this.modelFor('subscription-type.teacher-toolkit') as ModelFor<TeacherToolkitRoute>
    return { selectedCategory }
  }
}
